import { Link } from "react-router-dom";
import { CONTACT, PublicPage, Section, UPDATED } from "../../components/PublicLayout";
import { CodesTable } from "../../components/CodesTable";

export const CONSENT_FINAL =
  "I agree to receive recurring work-related text messages from GamedayTime (CampbellsLife LLC) at the mobile number provided, including phone verification codes, clock-in/clock-out links and confirmations, break confirmations, shift status replies and account notices. Message frequency varies. Message and data rates may apply. Reply HELP for help or STOP to opt out at any time. See our Privacy Policy and Terms.";

const STEPS: [string, string, string][] = [
  ["/sms-assets/step1-invitation.png", "Invitation email from GamedayTime with a personal registration link", "Your administrator invites you. You receive an invitation email from GamedayTime with a personal registration link. There is no public sign-up."],
  ["/sms-assets/step2-registration-form.png", "Registration form with name, email and mobile phone fields and an unchecked SMS consent checkbox showing the full consent text with Privacy Policy and Terms links", "On the registration page you enter your name, email and mobile number. The SMS consent checkbox is unchecked by default; you must check it yourself to continue. The full consent text and links to the Privacy Policy and Terms are shown next to it."],
  ["/sms-assets/step3-verify-code.png", "Phone verification step asking for the 6-digit code sent by text message", "We text a one-time verification code to the number you entered. Entering it confirms you own the phone."],
  ["/sms-assets/step4-welcome-text.png", "Welcome text message received on a phone confirming the number is verified, with HELP and STOP instructions", "After verification you receive one welcome text with HELP and STOP instructions."],
];

export default function SmsProgram() {
  return (
    <PublicPage testId="public-sms-page" eyebrow="Opt-in, keywords & support" title="SMS Guide" subtitle="GamedayTime Crew Notifications" updated={UPDATED}>
      <Section title="Who it's for">
        <p data-testid="sms-operator-line">GamedayTime is a DBA of CampbellsLife LLC. The program is for GamedayTime employees and crew members only, <strong>by invitation only</strong>. Crew text the program to clock in and out of shifts, and receive work-related notices.</p>
      </Section>
      <Section title="How opt-in works">
        <ol className="space-y-6" data-testid="sms-optin-steps">
          {STEPS.map(([src, alt, text], i) => (
            <li key={src} className="space-y-3">
              <p><span className="font-semibold text-white">Step {i + 1}.</span> {text}</p>
              <img src={src} alt={alt} loading="lazy" className="w-full max-w-sm rounded-[16px] border border-white/10" data-testid={`sms-step-${i + 1}-img`} />
            </li>
          ))}
        </ol>
      </Section>
      <Section title="Consent text (shown at registration)">
        <blockquote data-testid="sms-consent-text" className="rounded-[14px] border border-white/15 bg-white/[0.04] p-4 text-zinc-100">{CONSENT_FINAL}</blockquote>
      </Section>
      <Section title="Message types">
        <ul className="list-disc space-y-1 pl-5">
          <li>Verification codes</li><li>Clock-in/clock-out confirmation links and confirmations</li><li>Break confirmations</li>
          <li>Shift status replies</li><li>Account notices</li>
        </ul>
        <p>Message frequency varies. Message and data rates may apply.</p>
      </Section>
      <Section title="Keywords">
        <CodesTable testId="sms-keywords" />
      </Section>
      <Section title="Carriers, support and privacy">
        <p>Carriers are not liable for delayed or undelivered messages.</p>
        <p>Support: <a className="text-signal" href={`mailto:${CONTACT}`}>{CONTACT}</a></p>
        <p>We do not sell or share your mobile number or SMS opt-in consent with third parties for marketing purposes.</p>
        <p>See our <Link to="/privacy" className="text-signal" data-testid="sms-privacy-link">Privacy Policy</Link> and <Link to="/terms" className="text-signal" data-testid="sms-terms-link">Terms</Link>.</p>
      </Section>
    </PublicPage>
  );
}
